<div class="input-container no-border">
  <div class="row">
    <div class="column income-label">
      <span>{{ fieldsLabel | translate }}</span>
    </div>
    <div class="column">
      <div class="row">
        <div class="column">
          <app-form-input
            [errors]="errors"
            [label]="amountLabel"
            [placeholder]="placeholder"
            [(model)]="amount"
            (modelChange)="onAmountChange($event)"
          ></app-form-input>
        </div>
        <div class="column">
          <app-form-input
            [label]="resultLabel"
            [placeholder]="''"
            [(model)]="calculated"
            [isDisabled]="isDisabled"
          ></app-form-input>
        </div>
      </div>
    </div>
  </div>
</div>
